<template>
  <b-card :title="$t('label_reports_genderGap_generalSummary_outlook_title')">
    <div class="card-text mb-0" style="position: relative">
      {{ $t("label_reports_genderGap_generalSummary_outlook_description") }}
      <div
        v-if="isIndicaUser || isPNUDADMIN"
        class="AddComment"
        @click="newComment()"
      >
        {{ $t("label_reports_genderGap_addRecommendation")
        }}<span class="AddCommentPlus">+</span>
      </div>
      <b-modal
        id="modalInfo"
        v-model="showModal"
        size="xl"
        class="modal-improvements modalInfo"
        style="padding: 30px"
      >
        <h5 style="margin-bottom: 20px">
          {{ $t("label_reports_genderGap_recommendations") }}
        </h5>
        <div>
          {{ $t("label_reports_genderGap_recommendations_description") }}
        </div>
        <b-form-group label-class="text-sm-left">
          <b-form-textarea
            id="comment"
            v-model="comment"
            type="text"
            required
          />
        </b-form-group>
        <div slot="modal-footer" class="w-100" style="text-align: right">
          <b-button variant="primary" @click="saveComment()">
            {{ $t("label_evaluation_save_button") }}
          </b-button>
        </div>
      </b-modal>
    </div>

    <div v-if="backButtom" class="up">
      &larr;
      {{ $t("label_reports_genderGap_generalSummary_outlook_up_buttom") }}
    </div>
    <div :id="alias" class="feature" :style="{ height: height }" />
  </b-card>
</template>

<script>
import { mapGetters } from "vuex";
import { ChartTreemap } from "@/utils/ChartTreemap";
import { createHelpers } from "vuex-map-fields";
import { axiosCall } from "@/utils/axiosCall";
const { mapFields } = createHelpers({
  getterType: "getUserAccountField",
  mutationType: "updateUserAccountField",
});
// https://codepen.io/anon/pen/JejGxW

export default {
  name: "CardChartTreemapWithComment",
  props: {
    alias: {
      type: String,
      default: "treemapId",
    },
    height: {
      type: String,
      default: "400px",
    },
    backButtom: {
      type: Boolean,
      default: true,
    },
  },
  data: function () {
    return {
      showModal: false,
      comment: "",
      pillar: {},
    };
  },
  computed: {
    ...mapFields(["username"]),
    ...mapGetters(["pillarsData", "getCurrentSnapshot", "isPNUDADMIN", 'isIndicaUser']),
  },
  watch: {
    pillar: function () {
      this.createTreemap();
    },
  },
  created() {
    console.log("created treemap");
  },
  mounted() {
    console.log("mounted treemap");
    this.pillar = this.pillarsData();
    this.createTreemap();
    this.$store.watch(this.$store.getters.pillarsData, (n) => {
      var svg1 = this.$d3.select("#" + this.alias);
      svg1.selectAll(".node").remove();
      this.pillar = n;
      this.createTreemap();
    });

    // This let update the graphic when the language change
    this.unsubscribe = this.$store.subscribe((mutation) => {
      switch (mutation.type) {
        case "SET_LANG":
          var svg = this.$d3.select("#" + this.alias);
          svg.selectAll(".node").remove();
          this.createTreemap();
          break;
      }
    });
  },
  beforeDestroy() {
    console.log("Destroy Treemap!!!");
    this.unsubscribe();
  },
  updated() {},
  methods: {
    newComment() {
      this.comment = "";
      this.showModal = true;
    },
    saveComment: async function () {
      const data = {
        comment: this.comment,
        snapshotId: this.getCurrentSnapshot.snapshotId,
        // eslint-disable-next-line camelcase
        general: true,
      };
      await axiosCall({
        url: "GenderGapReportComments",
        method: "POST",
        data,
      }).then(() => {
        this.$emit("commentCreated");
        this.showModal = false;
      });
    },
    createTreemap: function () {
      this.treemap = new ChartTreemap(this.pillar, this.alias);
    },
  },
};
</script>

<style lang="scss" scoped>
/* components/cards/CardChartTreemap.vue */
@import "../../assets/css/variables.scss";

.up {
  font: bold 14px/1 $font-subtitle;
  color: white;
  padding: 8px;
  background-color: $primary-color;
  float: left;
  cursor: pointer;
  &:hover {
    background-color: $primary-pattern;
  }
}
.feature {
  position: relative;
  width: 100%;
  height: 100%;
  margin: 0px;
  overflow: hidden;
}

.node {
  position: absolute;
  background: transparent no-repeat 50% / cover;
  overflow: hidden;
  opacity: 1;
  transition: opacity 0.8s;
  cursor: pointer;
  border: 1px solid #fff;
  .label {
    display: inline;
    font-size: 1rem;
    font-family: $font-subtitle;
    position: absolute;
    padding: 0;
    margin: 0;
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
    transition: color 0.4s, opacity 0.8s, filter .8s;
    width: 90%;
    text-align: center;
    p {
      margin-bottom: 0rem;
    }
    .index {
      font-size: 1.2rem !important;
    }
    .leaf:hover {
      text-decoration: underline;
    }
  }
  &.hide {
    opacity: 0;
    pointer-events: none;
    .label {
      filter: blur(10px);
    }
  }
  &:hover {
    .label {
      opacity: 1;
    }
  }
  &.level-0 {
    z-index: 4;
    font-size: 15vmin;
    display: none;
  }
  &.level-1 {
    z-index: 3;
    font-size: 10vmin;
  }
  &.level-2 {
    z-index: 2;
    font-size: 5vmin;
  }
  &.level-3 {
    z-index: 1;
    font-size: 2.5vmin;
  }
}
.AddComment {
  color: #949293;
  position: absolute;
  bottom: -20px;
  right: 15px;
  font-weight: bold;
  cursor: pointer;
  .AddCommentPlus {
    font-size: 30px;
    font-weight: 100;
    background-color: #949293;
    color: #ffffff;
    padding: 2px;
    line-height: 29px;
    display: inline-block;
    margin-left: 10px;
  }
}
.card-title {
  text-align: left;
}
</style>
